/* eslint-disable */
import $ from 'jquery'

export default function postToInspectRealEstate(formData) {
    const state = formData.get('fields[state]')
    let accountName

    switch (state) {
        case 'VIC':
            accountName = 'littlevicparent'
            break
        default:
            accountName = 'littlenswparent'
    }

    const collectedData = {
        accountName,
        referrer: null,
        property: {
            streetNo: formData.get('fields[unit]'),
            street: formData.get('fields[address]'),
            suburb: formData.get('fields[suburb]'),
            state,
            postcode: formData.get('fields[postcode]'),
            bedrooms: formData.get('fields[bedrooms]'),
            bathrooms: formData.get('fields[bathrooms]'),
            garages: 0,
            carports: formData.get('fields[carSpaces]'),
            description: '',
            buildingName: '',
        },
        contact: {
            firstName: formData.get('fields[firstName]'),
            lastName: formData.get('fields[lastName]'),
            phone: formData.get('fields[phone]'),
            email: formData.get('fields[email]'),
            mobile: '',
            comments: formData.get('fields[comments]'),
            residentialAddress: null,
        },
        statusName: '',
        sourceName: '',
    }

    $.ajax({
        url: '/api/lead',
        type: 'POST',
        data: JSON.stringify(collectedData),
        dataType: 'text',
        async: false,
        headers: {
            'Content-Type': 'application/json',
        },
        success: function (data) {
            console.log('success')
        },
        error: function (error) {
            console.log(xhr.statusText)
            console.log(textStatus)
            console.log(error)
        },
    })
}
